module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAVCAMAAABrN94UAAAAYFBMVEUAAACQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpWQkpUtmZucAAAAH3RSTlMAk38Fe2b4jKaPg97Yy6uhmGEtFgjuwLlxbdORW0ZMKPnKkQAAALxJREFUKM9l0FsSgyAMBdCAlkIB8YHParP/XRYidYTmQ8OZSxiArHplEDXroahVCLeubhRL7jXKIf4HiUvu7Nc6cZvGyX1Fe0ZW5JfNdnHV6twZzhPuoenwmvMm5wDbFLodUz55DVCZObY65dXlEj8AfmzvzoM7fMSzsf/LP0hqmv8MX0X5hvxFcpz3ZdHlzWEyFVAVDoIn903mIOoir1LQ2tPzPL0K8wDD6Tw5RVs0imlyYOTXHivEfEBRX7KWDDiZF1vRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment.png
// module id = X36g
// module chunks = 9